import api, { fetchData } from "./api";
import CargoSearchList from "../types/cargoSearchList";
import Paginacao from "../types/paginacao";

export interface CargoSearchListApiResponse {
    data: CargoSearchList;
    messages: any; 
}

export const getListaCargoSearchList = async () => {
    try {
        const endpoint: string = "/CargoSearchList/all";
        const response = await fetchData<CargoSearchList>(endpoint, {});
        return response.data;
    } catch (error) {
        console.error("Erro ao buscar lista de cargoSearchList:", error);
        throw error;
    }
};

export const getListaCargoSearch = async () => {
    try {
        const endpoint: string = "/CargoSearchList/all";
        const response = await fetchData<CargoSearchList>(endpoint, {});
        return response;
    } catch (error) {
        console.error("Erro ao buscar lista de cargoSearchList:", error);
        throw error;
    }
};

export const getCargoSearchListPaginated = async (
    paginacao: Paginacao
  ) => {
    try {
      const endpoint: string = '/CargoSearchList/all/paginado';
      const params: Record<string, any> = {
        pageNum: paginacao.pageNum + 1,
        quantityPerPage: paginacao.quantityPerPage,
      };
  
      const response = await fetchData<CargoSearchList>(endpoint, params);
  
      return response;
    } catch (error) {
      console.error('Erro ao buscar lista de cargoSearchList:', error);
      throw error;
    }
};

export const getCargoSearchListById = async (id: number) => {
    try {
        const response = await api.get<CargoSearchListApiResponse>(`/CargoSearchList/${id}`);
        return response.data; 
    } catch (error) {
        console.error(`Erro ao buscar cargoSearchList com ID ${id}`, error);
        throw error;
    }
};

export const createCargoSearchList = async (cargo: CargoSearchList) => {
    try {
        const response = await api.post<CargoSearchListApiResponse>("/CargoSearchList", cargo);
        return response.data;
    } catch (error) {
        console.error("Erro ao criar cargoSearchList:", error);
        throw error;
    }
};

export const updateCargoSearchList = async (id: number, cargo: CargoSearchList) => {
    try {
        const response = await api.put<CargoSearchListApiResponse>(`/CargoSearchList/${id}`, cargo);
        return response.data;
    } catch (error) {
        console.error(`Erro ao atualizar cargoSearchList com ID ${id}:`, error);
        throw error;
    }
};

export const deleteCargoSearchList = async (id: number) => {
    try {
        await api.delete(`/CargoSearchList/${id}`);
        return true;
    } catch (error) {
        console.error(`Erro ao excluir cargoSearchList com ID ${id}:`, error);
        throw error;
    }
};
